import { render, staticRenderFns } from "./ChatVoice.vue?vue&type=template&id=fd638c12&scoped=true"
import script from "./ChatVoice.vue?vue&type=script&lang=js"
export * from "./ChatVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd638c12",
  null
  
)

export default component.exports